/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
 export const rebateProgramLabel = 'Rebate Program';
 export const quarterRangeLabel = 'Quarter Range';
 export const unallocatedBalanceLabel = 'Unallocated Balance';
 export const URAUsedLabel = 'URA Used';
 export const ARSummaryByQtrrLabel = 'AR Summary By Qtr';